import React, { useRef } from "react";
import { ReactElement } from "react";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import Hamburger from "./Hamburger";

interface MenuProps {
    children: (ReactElement | null)[];
}

const Menu = React.forwardRef<HTMLElement, MenuProps>(({ children }, ref) => {
    return (
        <nav
            ref={ref}
            className="z-40 fixed top-0 flex w-full flex-wrap  items-center justify-center gap-4 border-b border-xv-border-color bg-xv-bg-2 p-4 text-lg font-bold"
        >
            {children.map(
                (child, i) =>
                    child &&
                    React.cloneElement(child, {
                        key: i,
                        className:
                            "focus:outline-dotted focus:outline-1 hocus:brightness-90",
                    })
            )}
        </nav>
    );
});

export default Menu;
